// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jYx+y","content":"styles_content__c3xQR","decline":"styles_decline__RwAel"};